export default "__VITE_ASSET__BTDpJg8z__"